import React, { Fragment } from "react";

import { SupButton, SupText } from "@repo/core-ui";
import { SupAlert } from "@repo/core-ui";
import dictionaryConfig from "@/../config/dictionary.config";
import Link from "next/link";
import { twMerge } from "tailwind-merge";

interface Web3TransmuteCancelProps {
  handleCancel: () => void;
  handleOk: () => void;
  okLabel?: string;
  cancelLabel?: string;
  showLink?: boolean;
  title?: string;
  text?: string;
  reverseButtons?: boolean;
}
export default function Web3TransmuteCancel({
  handleCancel,
  handleOk,
  okLabel = "I’ll enable them later",
  cancelLabel = "No, Enable Rewards",
  showLink = true,
  title = "Are you sure you don’t want to Enable rewards?",
  text = "You will be unable to earn Superform rewards or underlying protocol rewards for this position until you transmute your SuperPosition.",
  reverseButtons = false,
}: Web3TransmuteCancelProps) {
  return (
    <Fragment>
      <div className="inline-flex w-full items-start justify-start gap-2.5 border border-[#E8684B]/40 bg-[#E8684B]/5 p-4 text-[#E8684B]">
        <SupAlert className="flex h-6 w-6 items-center justify-center" />
        <div className="shrink grow basis-0">
          <SupText variant="subtitle2" weight="bold">
            {title}
          </SupText>
          <SupText variant="subtitle2" as="div" className="my-3">
            {text}
          </SupText>
          {showLink && (
            <Link href={dictionaryConfig.superPools.helpArticle} className="text-[#E8684B] underline hover:no-underline" target="_blank">
              <SupText variant="caption" weight="bold" className="self-stretch ">
                Learn More
              </SupText>
            </Link>
          )}
        </div>
      </div>
      <div className={twMerge("mt-auto flex w-full flex-col items-stretch justify-between space-y-4", reverseButtons && "flex-col-reverse")}>
        <SupButton fluid onClick={() => handleCancel()} className="hover:opacity-80" variant="outlined" color="primary">
          {cancelLabel}
        </SupButton>
        <SupButton fluid onClick={() => handleOk()} className="hover:opacity-80" color="warning">
          {okLabel}
        </SupButton>
      </div>
    </Fragment>
  );
}
